import { z } from "zod/v4";

export const customFieldTypeSchema = z.enum([
	"text",
	"number",
	"date",
	"boolean",
	"single_select",
	"multi_select",
]);

export type CustomFieldType = z.infer<typeof customFieldTypeSchema>;

export const customFieldSchema = z.object({
	id: z.string().uuid(),
	club_id: z.string().uuid(),
	field_key: z.string(),
	label: z.string(),
	field_type: customFieldTypeSchema,
	options: z.unknown(),
	required: z.boolean(),
	position: z.number().int(),
	created_at: z.coerce.date(),
	updated_at: z.coerce.date(),
});

export type CustomField = z.infer<typeof customFieldSchema>;

export const customFieldValueSchema = z.object({
	club_id: z.string().uuid(),
	user_id: z.string().uuid(),
	field_id: z.string().uuid(),
	value: z.unknown(),
	updated_at: z.coerce.date(),
});

export type CustomFieldValue = z.infer<typeof customFieldValueSchema>;

export const createCustomFieldSchema = z.object({
	field_key: z
		.string()
		.min(1, "Field key is required")
		.regex(/^[a-z0-9_]+$/, "Use lowercase letters, digits, underscores"),
	label: z.string().min(1, "Label is required"),
	field_type: customFieldTypeSchema,
	options: z.unknown().optional(),
	required: z.boolean().optional(),
	position: z.number().int().optional(),
});

export const updateCustomFieldSchema = z.object({
	label: z.string().min(1).optional(),
	options: z.unknown().optional(),
	required: z.boolean().optional(),
	position: z.number().int().optional(),
});

export const setCustomValueSchema = z.object({
	value: z.unknown(),
});
